import { PermissionTypes } from 'features/permissions/types';

export const removeDynamicBroadcastPermissions = (dynamicPermissions: PermissionTypes[]) => {
  if (!dynamicPermissions) {
    return dynamicPermissions;
  }

  const permissionsToRemove = new Set([
    PermissionTypes.broadcastAudio,
    PermissionTypes.broadcastVideo,
  ]);

  return dynamicPermissions.filter((permission) => !permissionsToRemove.has(permission));
};
